// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // The main App component that includes routing

ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );